import httpClient from "../../api/httpClient";
import LogAlteracaoEtapa from "../classes/LogAlteracaoEtapa";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  { method: "GET", rota: "StepLogs" }
];

const apiServico: string = "PLANEJAMENTO";

export default class StepLogsDataset extends httpClient {
  constructor() {
    super(apiServico);
  }

  async get(id: number, type: string): Promise<LogAlteracaoEtapa[]> {
    let url: string = `${calls[0].rota}/${id}/${type}`;
    var result = await super.Get(url);
    return result.data;
  }
}
